import {POST} from "@/services/gateway";

export const listSeedingJobs = ({pagination}) => {
  return POST('seeding/salesforce-list', {pagination})
}
